/**
 * Help chat (Chat de dúvidas) API client.
 * Wraps apiGet/apiPost/apiFetch for /api/help endpoints.
 */

import { apiFetch, apiGet, apiPost } from '@/services/apiClient';

// ============================================================================
// TYPES
// ============================================================================

export interface HelpConfig {
  enabled: boolean;
}

export interface HelpConversation {
  id: string;
  title: string;
  updated_at: string;
  unread: number;
}

export interface HelpMessage {
  id: string;
  role: 'user' | 'assistant' | 'team';
  text: string;
  image_url: string | null;
  knew?: boolean | null;
  created_at: string;
  feedback: 1 | -1 | null;
}

export type HelpThread = { conversation: HelpConversation; messages: HelpMessage[] };

// ============================================================================
// CONFIG / CONVERSATIONS
// ============================================================================

export const getHelpConfig = () => apiGet<HelpConfig>('/api/help/config');

export const listHelpConversations = () =>
  apiGet<{ conversations: HelpConversation[] }>('/api/help/conversations');

export const openHelpConversation = (id: string) => apiGet<HelpThread>(`/api/help/conversations/${id}`);

export const deleteHelpConversation = (id: string) =>
  apiFetch<{ conversations: HelpConversation[] }>(`/api/help/conversations/${id}`, { method: 'DELETE' });

// ============================================================================
// MESSAGES
// ============================================================================

// Up to 55 s across primary and fallback model calls on the API side.
export const sendHelpMessage = (body: {
  conversation_id: string | null;
  message: string;
  image_base64?: string;
  image_mime?: string;
  screen: string;
  language: string;
}) => apiPost<HelpThread>('/api/help/messages', body, 70_000);

export const sendHelpFeedback = (messageId: string, value: 1 | -1) =>
  apiPost<{ ok: true }>(`/api/help/messages/${messageId}/feedback`, { value });

// ============================================================================
// UNREAD
// ============================================================================

export const getHelpUnread = () =>
  apiGet<{ conversation_id: string; total: number } | null>('/api/help/unread');
